import React, { Component } from 'react'
import { connect } from 'react-redux'

import { req_page_eps_teacher_vitality } from '../../api'
import { Card, Button, Table, Select, Input, Alert } from 'antd'
import { SearchOutlined } from '@ant-design/icons'

import { PAGE_SIZE, SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'

class VitalityIndexTeacherDissertation extends Component {
    state = {
        loading: false,
        deviceWidth: 0,
        userLevel: 'NORMAL',
        items: [],
        pagination: {
            current: 1,
            pageSize: PAGE_SIZE,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'None',
        searchValue: '',
        filterStatus: '',
        customizeStatus: 'OFF' 
    }

    UNSAFE_componentWillMount() {
        this.api_page_items()
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this))
        this.resize();
        this.init_columns()
    }

    componentWillUnmount(){
        window.removeEventListener("resize", this.resize.bind(this))
    }


    resize() {
        this.setState({ deviceWidth: window.innerWidth });
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus } = this.state
        const { token } = this.props.user
        this.setState({ loading: true, items: [] })
        const result = await req_page_eps_teacher_vitality('DISSERTATION', current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, token)
        this.setState({ loading: false })
        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(this.state);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 
    init_columns = () => {
        this.columns = [
            {
                title: '項目',
                dataIndex: 'Catalog',
                width: 70,
            },
            {
                title: '科系/部門',
                dataIndex: 'DepartmentTwName',
                width: 100,
                responsive: ['md'],
            },
            {
                title: '職號',
                dataIndex: 'BloggerCode',
                width: 50,
                responsive: ['md'],
            },
            {
                title: '姓名',
                dataIndex: 'TwName',
                width: 65,
            },
            {
                title: '數量',
                dataIndex: 'Total',
                width: 50,
            },
        ]
    }

    style_switch_color_tag(column) {
        let ans = 'black'
        switch (column) {
            case 'NOTSTART':
                ans = 'gray'
                break;
            default:
                ans = 'black'
                break;
        }
        return ans
    }

    style_switch_text_tag(column) {
        let ans = 'black'
        switch (column) {
            case 'NOTSTART':
                ans = '尚未開放'
                break;
            default:
                ans = '未知狀態'
                break;
        }
        return ans
    }

    // 操作互動處理 //////////////////////////////////////////////

    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    /////////////////////////////////////////////////////////////
    render() {
        const { loading, items, pagination, searchField, searchValue } = this.state
        const title = (
            <span>
                <Select value={searchField} style={{ width: 120 }} onChange={value => this.setState({ searchField: value })}>
                    <Select.Option value='None'>搜索條件</Select.Option>
                    <Select.Option value='TwName'>姓名</Select.Option>
                    <Select.Option value='DepartmentTwName'>部門</Select.Option>
                </Select>
                <Input placeholder="關鍵字" style={{ width: 150, margin: '0 5px' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                <Button type='primary' icon={<SearchOutlined />} onClick={() => this.api_page_items(1)}>查詢</Button>
            </span>
        )
        const extra = (
            <Alert message="資料來源：研發處(研究管理系統)" type="info" showIcon />
        )
        return (
            <Card title={title} extra={extra}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='Id'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(VitalityIndexTeacherDissertation)